var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcellence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9948 21.3264C21.1478 21.3264 25.3251 17.149 25.3251 11.9961C25.3251 6.84309 21.1478 2.66577 15.9948 2.66577C10.8419 2.66577 6.66455 6.84309 6.66455 11.9961C6.66455 17.149 10.8419 21.3264 15.9948 21.3264Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33032 26.9699V18.6606C10.2194 19.5496 12.7959 21.3264 15.9948 21.3264C19.1938 21.3264 21.7703 19.5496 22.6593 18.6606V26.9699C22.6591 27.2056 22.5964 27.437 22.4776 27.6406C22.3588 27.8442 22.1881 28.0127 21.983 28.1288C21.7779 28.2449 21.5456 28.3045 21.3099 28.3016C21.0742 28.2987 20.8435 28.2333 20.6413 28.1122L16.6799 25.7369C16.4729 25.6129 16.2361 25.5474 15.9948 25.5474C15.7535 25.5474 15.5167 25.6129 15.3097 25.7369L11.3483 28.1108C11.1462 28.2319 10.9156 28.2973 10.6801 28.3003C10.4445 28.3033 10.2123 28.2437 10.0072 28.1278C9.80211 28.0118 9.63142 27.8436 9.51251 27.6402C9.39361 27.4368 9.33074 27.2055 9.33032 26.9699Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcellence);
export default __webpack_public_path__ + "static/media/Excellence.d7e8608b5bdf1eecb0c0afc1f8e06160.svg";
export { ForwardRef as ReactComponent };